import React, { memo } from 'react';
import CartShimmer from './CartShimmer';
import OrderSummaryShimmer from '../../molecules/orderSummaryFactory/components/orderSummaryShimmer/OrderSummaryShimmer';
import FooterShimmer from './FooterShimmer';
import { cartDatalocator } from '../utils/dataLocators';

const CartPageShimmer = () => (
    <section className="cart-page__content">
        <div className="container">
            <div className="row">
                <div className="col-12 cart-page__left" data-testid={cartDatalocator?.cart_shimmer}>
                    <CartShimmer />
                </div>
                <div className="col-12 cart-page__right">
                    <div className="cart-page__right-wrap" data-testid={cartDatalocator?.cart_order_summary_shimmer}>
                        <OrderSummaryShimmer />
                        <div className="cart-footer-section" data-testid={cartDatalocator?.cart_footer_shimmer}>
                            <FooterShimmer />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default memo(CartPageShimmer);
